import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleModalWithTimer } from 'apps/auth/actions/appAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { ID_IN_REVIEW_SCREEN_GOT_IT_CLICKED, INCREASE_LIMITS_DOCUMENTS_SUBMITTED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { KYC_PROVIDER } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { SUMSUB } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

const KYCSumsubStatus = (props) => {
    useEffect(() => {
        if (props.status === 'success') {
            amplitude.getInstance().logEvent(INCREASE_LIMITS_DOCUMENTS_SUBMITTED, { [KYC_PROVIDER]: SUMSUB });
        }
    }, []);
    const renderText = (text) => {
        return MarkdownService.splitByParagraph(text || '', [], { color: 'secondary' });
    };
    return (
        <BaseLayout showChat={false}>
            <InfoPage
                iconName={props.status !== 'fail' ? 'clock-80' : ''}
                iconColor={props.status !== 'fail' ? 'primary' : ''}
                animatedIconFail={props.status === 'fail'}
                headerText={<DangerouslyHtml sanitizeAllHtmlTags dangerouslyHtml={props.screenTitle} />}
                secondaryText={renderText(props.text)}
                primaryButtonCaption={props.gotItButton}
                primaryButtonType="link"
                primaryButtonLink={AUTH_SEND_MAIN_LINK}
                primaryButtonOnClick={() => {
                    props.status === 'success' ? amplitude.getInstance().logEvent(ID_IN_REVIEW_SCREEN_GOT_IT_CLICKED, { [KYC_PROVIDER]: SUMSUB }) : null;
                }}
            />
        </BaseLayout>
    );
};

const mapStateToProps = ({ extra, messages: { pageMessages } }) => ({
    status: extra.status,
    linkAfterModal: extra.linkAfterModal,
    getIbanAfterReview: pageMessages.getIbanAfterReview,
    screenTitle: pageMessages.screenTitle,
    text: pageMessages.screenText,
    gotItButton: pageMessages.emailCheckInboxGotItButton,
});
export default connect(mapStateToProps, { toggleModalWithTimer })(BasePage(KYCSumsubStatus));
